// extracted by mini-css-extract-plugin
export var menuIcon = "_u7-0";
export var menuIconInline = "_u7-1";